import axios from 'axios';

class ArchiveFilters
{
    constructor ( $strBaseUrl = '/articles' )
    {

        this.baseNewsIndexUrl = $strBaseUrl;

        this.dropdownContainers = document.querySelectorAll( '.post-archive .taxonomy-dropdown, .author-presentation' );

        if ( this.dropdownContainers.length < 1 )
        {
            return;
        }

        this.postsContainer = document.querySelector( '.found-posts' );

        this.selects = document.querySelectorAll( '.post-archive .taxonomy-dropdown select, .author-presentation select' );

        this.hasSubthemeFilters = Array.from( this.selects ).filter( el => el.name === 'taxonomy-subthemes[]' ).length > 0;

        let hiddenTerm = document.querySelector( "#received_term" );
        this.term      = hiddenTerm ? hiddenTerm.value : "";

        this.adjustBaseUrlBasedOnSort();

        this.compileAllFilters( false );

        this.setupPagination();

        this.makeDropdownsPretty();

        this.bindEvents();

        this.adjustSubThemesOptions();
    }


    bindEvents ()
    {

        $( this.selects ).on( 'change', ( event ) =>
        {
            this.compileAllFilters( event.target );

            this.adjustSubThemesOptions();
        } );


    }


    adjustBaseUrlBasedOnSort ()
    {
        const sortDropdown = Array.from( this.selects ).find( el => el.name === 'taxonomy-sort-order[]' );

        if ( !sortDropdown )
        {
            return;
        }

        this.audienceMode = sortDropdown?.dataset?.audience ?? 'jeunes';

        //MT: not sure if this is needed anymore. 2023-04-14 13:00
        // if ( 'profs' === this.audienceMode )
        // {
        //     this.baseNewsIndexUrl = '/profs/articles';
        // }

    }

    compileAllFilters ( navigateTo = true )
    {
        this.currFilters = [];


        Array.from( this.selects )
            .forEach( ( el, i ) =>
            {

                let value = el.value;

                if ( value !== '' )
                {


                    const name = el.getAttribute( 'name' );

                    if ( typeof this.currFilters[ name ] === 'undefined' )
                    {
                        this.currFilters[ name ] = [];
                    }


                    if ( [
                        'taxonomy-themes[]',
                        'taxonomy-subthemes[]',
                        'taxonomy-types[]',
                    ].includes( name ) )
                    {
                        value = parseInt( value );
                    }

                    this.currFilters[ name ].push( value );

                }
            } );


        if ( navigateTo )
        {

            let prettyFrenchQueryVars = {};
            let anyFilters            = false;

            if ( this.currFilters[ 'taxonomy-sort-order[]' ] )
            {
                prettyFrenchQueryVars.tri = this.currFilters[ 'taxonomy-sort-order[]' ];
                anyFilters                = true;
            }

            if ( this.currFilters[ 'taxonomy-themes[]' ] )
            {
                prettyFrenchQueryVars.thematiques = this.currFilters[ 'taxonomy-themes[]' ].map( val => parseInt( val ) );
                anyFilters                        = true;
            }

            if ( this.currFilters[ 'taxonomy-subthemes[]' ] )
            {
                prettyFrenchQueryVars[ 'sous-themes' ] = this.currFilters[ 'taxonomy-subthemes[]' ].map( val => parseInt( val ) );
                anyFilters                             = true;
            }

            if ( this.currFilters[ 'taxonomy-types[]' ] )
            {
                prettyFrenchQueryVars.types = this.currFilters[ 'taxonomy-types[]' ].map( val => parseInt( val ) );
                anyFilters                  = true;
            }


            if ( this.currFilters[ 'taxonomy-audiences[]' ] )
            {
                prettyFrenchQueryVars.audiences = this.currFilters[ 'taxonomy-audiences[]' ];
                anyFilters                      = true;
            }

            if ( this.term !== "" )
            {
                prettyFrenchQueryVars.terme = this.term;
                anyFilters                  = true;
            }


            if ( anyFilters )
            {
                const wantedUrl = this.baseNewsIndexUrl + '?' + new URLSearchParams( prettyFrenchQueryVars ).toString();
                if ( wantedUrl )
                {
                    window.location = wantedUrl;
                }
            }

        }
    }


    makeDropdownsPretty ()
    {

        let selectOptions = {
            minimumResultsForSearch : Infinity,
        };

        Array.from( this.selects ).forEach( sel =>
        {

            const $sel    = $( sel );
            const $parent = $sel.parent();

            selectOptions.dropdownParent = $parent;


            $sel.select2( selectOptions );
        } )
    }


    adjustSubThemesOptions ()
    {

        if ( !this.hasSubthemeFilters )
        {
            return;
        }

        const hasChosenTheme  = typeof this.currFilters[ 'taxonomy-themes[]' ] !== 'undefined' && this.currFilters[ 'taxonomy-themes[]' ].length > 0;
        const chosenTheme     = hasChosenTheme ? this.currFilters[ 'taxonomy-themes[]' ] : [];
        const subthemeOptions = Array.from( this.selects )
            .filter( s => s.name === 'taxonomy-subthemes[]' )[ 0 ].querySelectorAll( 'option' );

        Array.from( subthemeOptions ).forEach( opt =>
        {

            const optionParentId = parseInt( opt.dataset.parentThemeId );

            opt.disabled = hasChosenTheme && optionParentId > 0 && this.currFilters[ 'taxonomy-themes[]' ].includes( optionParentId ) === false;


        } )
    }


    setupPagination ()
    {

        this.btnLoadMore = document.querySelector( '.post-archive .btn-load-more' );

        if ( this.btnLoadMore === null )
        {
            return;
        }


        this.isSearch = [ 'true', 1, true, 'TRUE' ].includes( this.btnLoadMore?.dataset?.isSearch ?? false )


        this.pagination = {
            currentPage : parseInt( this.btnLoadMore.dataset.currentPage ),
            lastPage    : parseInt( this.btnLoadMore.dataset.lastPage ),
            nextPageUrl : this.btnLoadMore.dataset.nextPageUrl,
        };

        this.audience = this.btnLoadMore.dataset.audience;


        if ( this.pagination.currentPage === this.pagination.lastPage )
        {
            this.btnLoadMore.disabled = true;
        }


        this.btnLoadMore.addEventListener( 'click', this.getAdditionalPaginatedResults.bind( this ) );

    }

    async getAdditionalPaginatedResults ()
    {

        if ( this.pagination.currentPage === this.pagination.lastPage )
        {
            return;
        }

        const urlSearchParams = new URLSearchParams( window.location.search );
        const params          = Object.fromEntries( urlSearchParams.entries() );


        this.btnLoadMore.classList.add( 'ajaxing' );
        this.btnLoadMore.disabled = true;

        const elAuthorId = document.querySelector( "[data-id-author]" );
        const authorId   = elAuthorId ? elAuthorId.dataset.idAuthor : 0;


        let loadMoreOptions = {
            page          : this.pagination.currentPage + 1,
            tri           : params?.tri ?? 'date',
            types         : params?.types ?? [],
            thematiques   : params?.thematiques ?? [],
            authorIds     : authorId != 0 ? [ authorId ] : [],
            'sous-themes' : params[ 'sous-themes' ] ?? [],
            audience      : this.audience,
            terme         : this.term,
        }

        if ( this.isSearch )
        {
            loadMoreOptions.isSearch = true;
        }


        let response = await axios.get( `/endpoints/paginatedArchive`, { params : loadMoreOptions } );


        this.btnLoadMore.classList.remove( 'ajaxing' );
        this.btnLoadMore.disabled = false;


        this.pagination.currentPage = response.data.currentPage;
        this.pagination.lastPage    = response.data.lastPage;

        this.btnLoadMore.disabled = this.pagination.currentPage === this.pagination.lastPage;


        if ( typeof response.data.templatedPosts !== 'undefined' && response.data.templatedPosts.length > 0 )
        {
            this.postsContainer.innerHTML += response.data.templatedPosts.join( "\n" );
        }


    }

}


document.addEventListener( 'DOMContentLoaded', () =>
{
    let body = document.querySelector( "body" );

    let isSearch = body.hasAttribute( "data-is-search" );

    let isTeacher = body.hasAttribute( "data-for-teacher" );
    let pageId    = (body.attributes[ "data-page-id" ].value ?? "");
    let url;

    if ( !isSearch )
    {
        if ( [ 'author-post-archive' ].includes( pageId ) ) //we are in the author page
        {
            url = location.protocol + '//' + location.host + location.pathname;
        } else //we are in the "Toutes les nouvelles" page
        {
            url = isTeacher ? "/profs/articles" : "/articles";
        }
    } else
    {
        url = isTeacher ? "/profs/recherche" : "/recherche";
    }


    const archiveFilters = new ArchiveFilters( url );
} )
